import { createStyles, makeStyles } from "@material-ui/core";
import theme, { COLORS } from "../config/theme/baseTheme";

export const useStyles = makeStyles(() =>
  createStyles({
    dialogPaperPropsRoot: {
        position: 'absolute',
        right: '8%',
        top: '2%',
        padding: '0px',
        maxWidth: '500px',
        minWidth: '500px',
        maxHeight: '80vh',
        '& .MuiDialogContent-root': {
          padding: '0px',
        },
        '& .MuiDialogTitle-root':{
          padding: '16px 24px',
        }
    },
    stickyTabs: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: 'white', // Match the background color
       borderBottom: "1px solid #E6E6E6"
       
    },
    
    Heading: {
     fontSize: "20px", 
     fontWeight: "bold"
    },
    unreadDot: {
      height: "8px",
      width: "8px",
      borderRadius: "50%",
      backgroundColor: COLORS.PRIMARY_MAIN,
      marginRight: "8px",
      position: "relative",
      "&:hover": {
        cursor: "pointer",
        boxShadow: "0 0 0 8px rgba(0, 0, 0, 0.1)", // Grey circle around the dot
      },
    },
    consignmentCode: {
      fontWeight: 600,
      fontSize: "14px",
      color: COLORS.PRIMARY_MAIN,
      lineHeight: 1.5,
      marginLeft: "8px", // Add padding from the unread dot
      whiteSpace: "pre-wrap", wordBreak: "break-word"
    },
    secondaryText: {
      marginLeft: "24px", // Add padding from the unread dot for secondary text
      lineHeight: 1.5,
      fontSize: "14px",
      fontWeight: 600,
    },
    unreadNotification: {
     // backgroundColor: COLORS.BLUE_BACKGROUND, // Light background for unread notifications
      width: "100%", // Increase row width
      padding: theme.spacing(2, 2), // Add padding
      "&:hover": {
        backgroundColor: COLORS.BLUE_BACKGROUND, // Disable hover effect
      },
    },
    readNotification: {
      width: "100%", // Increase row width
      padding: theme.spacing(2, 2), // Add padding
      "&:hover": {
        backgroundColor: "inherit", // Disable hover effect
      },
    }, 
    markAllAsRead: {
      cursor: "pointer",
      color: COLORS.PRIMARY_MAIN,
      fontSize: "12px",
    },
    timeText: {
      fontSize: "12px",
      color: COLORS.PRIMARY_MAIN, // Use a subtle color for the time text
      marginLeft: "16px", // Push the time text to the right
       whiteSpace: "nowrap"
    },
    noData:{
      textAlign: "center",
      marginBottom: theme.spacing(2),
    }
  }),
);
